// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/home/styles/Areas.scss
// module id = 1543
// module chunks = 0